/* ec-drawer.js — gedrag van de theme-native cart drawer.
   Rendert uit /cart.js, dus wat je ziet is altijd wat Shopify daadwerkelijk
   in de winkelwagen heeft staan — inclusief kortingen die Shopify zelf toekent. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ecd]');
  if (!root) return;

  var overlay = document.querySelector('[data-ecd-overlay]');
  var cfgEl = document.querySelector('[data-ecd-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }

  var TIERS = parseTiers(CFG.reward && CFG.reward.tiers);
  var upsellsLoaded = false;

  // Taal: Shopify's locale bepaalt de teksten; thema-instellingen winnen als ze gevuld zijn.
  var LOCALE = String(CFG.locale || (window.Shopify && Shopify.locale) || 'nl').slice(0, 2).toLowerCase();
  var I18N = (CFG.i18n && (CFG.i18n[LOCALE] || CFG.i18n.nl)) || {};
  function t(key, override) {
    // Een thema-instelling wint alleen als de eigenaar 'm ECHT zelf heeft aangepast.
    // De defaults zijn Nederlands; stond die check er niet, dan zou een Franse of
    // Poolse klant de Nederlandse standaardtekst zien omdat de instelling 'gevuld' is.
    if (override !== undefined && override !== null && String(override).trim() !== '') {
      var dutchDefault = (CFG.i18n && CFG.i18n.nl && CFG.i18n.nl[key]) || '';
      if (String(override).trim() !== String(dutchDefault).trim()) return override;
    }
    return I18N[key] || '';
  }

  // /cart.js levert GEEN compare_at_price en GEEN variantenlijst; allebei komen uit
  // /products/{handle}.js. We cachen het HELE product, want zowel de vanafprijs als
  // de maat/kleur-dropdown leest eruit — één fetch per product per sessie.
  var productCache = {};
  function loadProducts(cart) {
    var handles = [];
    cart.items.forEach(function (i) { if (handles.indexOf(i.handle) < 0) handles.push(i.handle); });
    var missing = handles.filter(function (h) { return !productCache[h]; });
    if (!missing.length) return Promise.resolve();
    return Promise.all(missing.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); })
        .then(function (p) { productCache[h] = p || {}; })
        // Faalt de fetch, dan cachen we een leeg product: geen vanafprijs en geen
        // dropdown, maar de regel zelf blijft gewoon werken.
        .catch(function () { productCache[h] = {}; });
    }));
  }
  function variantsFor(item) {
    var p = productCache[item.handle];
    return (p && p.variants) || [];
  }
  function compareAtFor(item) {
    var v = null;
    variantsFor(item).forEach(function (x) { if (x.id === item.variant_id) v = x; });
    var c = v && v.compare_at_price;
    return (c && Number(c) > item.original_price) ? Number(c) : null;
  }

  function parseTiers(raw) {
    // "2:15%:15% EXTRA KORTING, 3:20%:20% EXTRA KORTING"
    if (!raw) return [];
    return String(raw).split(',').map(function (chunk) {
      var p = chunk.split(':').map(function (s) { return s.trim(); });
      var min = parseInt(p[0], 10);
      if (!min) return null;
      return { min: min, name: p[1] || '', message: p[2] || p[1] || '' };
    }).filter(Boolean).sort(function (a, b) { return a.min - b.min; });
  }

  function money(cents) {
    var fmt = CFG.moneyFormat || '€{{amount_with_comma_separator}}';
    var amount = (cents / 100);
    var withComma = amount.toFixed(2).replace('.', ',');
    var withDot = amount.toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(amount)).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(amount)))
      .replace(/\{\{\s*amount\s*\}\}/g, withDot);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function el(sel) { return root.querySelector(sel); }

  // De upsell-knop volgt de variantkeuze in dezelfde kaart; zonder keuze de eerste variant.
  function selectedVariantFor(btn) {
    var card = btn.closest('.ecd-upsell-product');
    var sel = card && card.querySelector('[data-ecd-upsell-variant]');
    return (sel && sel.value) || btn.getAttribute('data-ecd-upsell-add');
  }

  // Statische teksten in de juiste taal zetten (thema-instelling wint als 'ie gevuld is).
  (function applyI18n() {
    // De thema-instelling staat al in de markup; die WINT. Alleen als 'ie leeg is
    // (of gelijk aan de nl-standaard) vullen we de vertaling in.
    var set = function (sel, key) {
      var e = el(sel); if (!e) return;
      var current = (e.textContent || '').trim();
      var dutchDefault = (CFG.i18n && CFG.i18n.nl && CFG.i18n.nl[key]) || '';
      var eigenTekst = current && current !== dutchDefault;
      if (eigenTekst) return;                 // eigenaar heeft 'm zelf gezet -> laten staan
      var val = I18N[key]; if (!val) return;
      e.textContent = val;
    };
    var titleEl = el('[data-ecd-title]');
    if (titleEl && I18N.title) {
      titleEl.innerHTML = esc(I18N.title) + ' • <span data-ecd-count>' +
        (titleEl.querySelector('[data-ecd-count]') || { textContent: '0' }).textContent + '</span>';
    }
    set('.ecd-upsell-title', 'upsellTitle');
    set('.ecd-subtotal-label', 'subtotal');
    set('.ecd-discount-label', 'discount');
    set('.ecd-checkout', 'checkout');
    // aria-labels die in de markup staan
    root.querySelectorAll('[data-ecd-aria]').forEach(function (e) {
      var v = I18N[e.getAttribute('data-ecd-aria')];
      if (v) e.setAttribute('aria-label', v);
    });
    var closeBtn = el('[data-ecd-close]');
    if (closeBtn && I18N.ariaClose) closeBtn.setAttribute('aria-label', I18N.ariaClose);

    var ann = el('.ecd-announcement');
    if (ann && I18N.announcement && !ann.dataset.custom) ann.innerHTML = '<p>' + I18N.announcement + '</p>';
  })();

  // ── Openen / sluiten ──────────────────────────────────────────────
  var lastFocus = null;

  // De EA Sticky Cart-app gebruikt z-index 2147483647 — exact hetzelfde maximum als
  // wij (32-bit bovengrens, hoger kan niet). Bij een gelijkspel wint wie LATER in de
  // DOM staat, en EA hangt z'n paneel er pas bij het openen aan. Vandaar: bij elke
  // opening onze drawer naar het einde van <body> verplaatsen, zodat wij de laatste
  // zijn. Het element is position:fixed, dus verplaatsen verandert niets aan de lay-out.
  function bringToFront() {
    try {
      if (overlay) document.body.appendChild(overlay);
      document.body.appendChild(root);
    } catch (e) {}
  }

  function open() {
    lastFocus = document.activeElement;
    bringToFront();
    document.body.classList.add('ecd-open');
    root.hidden = false; if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    root.focus();
    refresh();
  }

  function close() {
    document.body.classList.remove('ecd-open');
    root.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      root.hidden = true; if (overlay) overlay.hidden = true;
    }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // ── Renderen ──────────────────────────────────────────────────────
  function renderItems(cart) {
    var wrap = el('[data-ecd-items]');
    if (!wrap) return;

    if (!cart.items.length) {
      wrap.innerHTML =
        '<div class="ecd-empty">' +
        (CFG.emptyImage ? '<img src="' + esc(CFG.emptyImage) + '" alt="">' : '') +
        '<p>' + esc(t('empty', CFG.emptyText)) + '</p>' +
        '<a href="/collections/all">' + esc(t('emptyBtn', CFG.emptyButtonText)) + '</a>' +
        '</div>';
      return;
    }

    wrap.innerHTML = cart.items.map(function (item, index) {
      if (protVariantId && item.variant_id === protVariantId) return '';   // eigen blok in de footer
      var img = item.image
        ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')) + '" alt="' + esc(item.product_title) + '" loading="lazy">'
        : '';

      // Variant-keuze: ALLE varianten van het product, zodat de klant maat of kleur
      // kan wisselen zonder de regel te verwijderen. Onder de twee varianten valt er
      // niets te kiezen (o.a. 'Default Title'), dan tonen we geen dropdown.
      // Uitverkochte varianten staan er wel in maar zijn disabled — anders lijkt het
      // alsof een maat niet bestaat terwijl 'ie alleen op is.
      var variantHtml = '';
      var variants = variantsFor(item);
      if (variants.length > 1) {
        var opts = variants.map(function (v) {
          var label = v.title + (v.available ? '' : ' \u2014 ' + t('soldOut'));
          return '<option value="' + v.id + '"' +
            (v.id === item.variant_id ? ' selected' : '') +
            (v.available ? '' : ' disabled') +
            '>' + esc(label) + '</option>';
        }).join('');
        variantHtml =
          '<div class="ecd-item-variant"><select data-ecd-variant' +
          ' data-current="' + item.variant_id + '"' +
          ' data-line="' + (index + 1) + '"' +
          ' aria-label="' + esc(t('ariaVariant')) + '">' + opts + '</select></div>';
      }

      // Vanafprijs (79,95) doorgestreept naast de actuele prijs (39,95).
      var compareAt = compareAtFor(item);
      var wasPrice = compareAt
        ? '<span class="ecd-item-price-was">' + money(compareAt * item.quantity) + '</span>'
        : (item.original_line_price > item.final_line_price
            ? '<span class="ecd-item-price-was">' + money(item.original_line_price) + '</span>' : '');

      return '' +
        '<div class="ecd-item"><div class="ecd-item-frame"><div class="ecd-item-row">' +
          '<div class="ecd-item-image">' + img + '</div>' +
          '<div class="ecd-item-details">' +
            '<a class="ecd-item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            variantHtml +
          '</div>' +
          '<div class="ecd-item-side">' +
            '<div class="ecd-item-price">' +
              '<span class="ecd-item-price-now">' + money(item.final_line_price) + '</span>' + wasPrice +
            '</div>' +
            '<div class="ecd-item-actions">' +
              '<button type="button" class="ecd-item-remove" data-ecd-remove data-line="' + (index + 1) + '" aria-label="' + esc(t('ariaRemove')) + '">' +
                '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2.5 4h11M6 4V2.5h4V4M4 4l.7 9.5h6.6L12 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '</button>' +
              '<div class="ecd-qty">' +
                '<button type="button" data-ecd-qty="-1" data-line="' + (index + 1) + '" aria-label="' + esc(t('ariaLess')) + '">' +
                  '<svg viewBox="0 0 12 12" aria-hidden="true"><line x1="2" y1="6" x2="10" y2="6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
                '</button>' +
                '<span class="ecd-qty-value">' + item.quantity + '</span>' +
                '<button type="button" data-ecd-qty="1" data-line="' + (index + 1) + '" aria-label="' + esc(t('ariaMore')) + '">' +
                  '<svg viewBox="0 0 12 12" aria-hidden="true"><line x1="2" y1="6" x2="10" y2="6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><line x1="6" y1="2" x2="6" y2="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div></div></div>';
    }).join('');
  }

  function renderReward(cart) {
    var box = el('[data-ecd-reward]');
    if (!box || !TIERS.length) return;
    box.hidden = false;

    // De verzendbescherming telt NIET mee voor de staffel. Gecontroleerd gemeten
    // (27-08): 2 echte producten = 15% met én zonder bescherming; 1 echt product +
    // bescherming = geen korting. Shopify's kortingsregel kijkt dus naar de echte
    // producten, en de balk moet dat volgen — anders zou 'ie bij 2 producten +
    // bescherming de 20%-trede als behaald tonen terwijl de klant 15% krijgt.
    var count = cart.item_count;
    if (protVariantId) {
      cart.items.forEach(function (i) { if (i.variant_id === protVariantId) count -= i.quantity; });
    }
    var reached = TIERS.filter(function (t) { return count >= t.min; }).length;
    var next = TIERS[reached];

    // Vulling in gelijke segmenten per tier — zo staat de balk op 50% zodra de
    // eerste van twee tiers gehaald is, exact als de live drawer.
    var pct;
    if (!next) {
      pct = 100;
    } else {
      var prevMin = reached ? TIERS[reached - 1].min : 0;
      var within = (count - prevMin) / Math.max(next.min - prevMin, 1);
      pct = ((reached + Math.min(Math.max(within, 0), 1)) / TIERS.length) * 100;
    }
    el('[data-ecd-reward-fill]').style.width = pct.toFixed(2) + '%';

    var textEl = el('[data-ecd-reward-text]');
    if (next) {
      var remaining = next.min - count;
      var before = t('rewardBefore', CFG.reward.beforeText);
      textEl.innerHTML = String(before).replace(/\{remaining[^}]*\}/g, remaining);
    } else {
      var last = TIERS[TIERS.length - 1];
      var done = t('rewardDone', CFG.reward.completedText);
      textEl.innerHTML = String(done).replace(/\{name\}/g, esc(last.name));
    }

    var holder = el('[data-ecd-reward-milestones]');
    holder.innerHTML = TIERS.map(function (t, i) {
      var left = ((i + 1) / TIERS.length) * 100;
      // Eigenaar 27-08: de zwarte ring markeert BEHAALDE treden, zodat de klant
      // ziet waar 'ie staat. Trede i is behaald zodra i < reached (reached telt
      // hoeveel treden gehaald zijn, en telt de verzendbescherming niet mee).
      var isReached = i < reached;
      return '<div class="ecd-reward-milestone" style="left:' + left + '%">' +
        '<div class="ecd-reward-icon' + (isReached ? ' is-reached' : '') + '">' +
          // Exact het icoon uit de Essential-drawer: kortingsbadge (gekartelde cirkel
          // met procentteken), massief zwart. Het icoon zelf is voor BEIDE treden
          // gelijk (net als bij Essential); behaald/niet-behaald zie je aan de
          // balkvulling EN aan de zwarte ring (.is-reached).
          '<svg viewBox="0 0 20 20" aria-hidden="true">' +
            '<path fill-rule="evenodd" fill="#000000" d="M11.527 3.327c-.6-1.306-2.455-1.306-3.054 0a1.68 1.68 0 0 1-2.112.874c-1.347-.5-2.66.813-2.16 2.16a1.68 1.68 0 0 1-.874 2.112c-1.306.6-1.306 2.455 0 3.054a1.68 1.68 0 0 1 .874 2.112c-.5 1.347.813 2.659 2.16 2.16a1.68 1.68 0 0 1 2.112.874c.6 1.306 2.455 1.306 3.054 0a1.68 1.68 0 0 1 2.112-.874c1.347.499 2.66-.813 2.16-2.16a1.68 1.68 0 0 1 .874-2.112c1.306-.6 1.306-2.455 0-3.054a1.68 1.68 0 0 1-.874-2.112c.5-1.347-.813-2.66-2.16-2.16a1.68 1.68 0 0 1-2.112-.874Zm-2.527 4.923a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3.53.53-4 4a.75.75 0 1 1-1.06-1.06l4-4a.75.75 0 1 1 1.06 1.06Zm.47 3.47a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>' +
          '</svg>' +
        '</div>' +
        '<div class="ecd-reward-label">' + esc(t.name) + '</div>' +
        '</div>';
    }).join('');
  }

  function renderTotals(cart) {
    el('[data-ecd-subtotal]').textContent = money(cart.total_price);
    var countEl = el('[data-ecd-count]');
    if (countEl) countEl.textContent = cart.item_count;

    // Kortingsrij: puur weergave van wat Shopify zelf meldt.
    var wrap = el('[data-ecd-discount-wrap]');
    if (!wrap) return;
    // Twee soorten besparing bij elkaar: de staffel-/codekorting die Shopify toekent
    // EN het verschil tussen vanafprijs en actuele prijs.
    var apps = cart.cart_level_discount_applications || [];
    var compareSavings = 0;
    cart.items.forEach(function (i) {
      var c = compareAtFor(i);
      if (c) compareSavings += (c - i.original_price) * i.quantity;
    });
    var total = (cart.total_discount || 0) + compareSavings;
    if (!total) { wrap.hidden = true; return; }
    wrap.hidden = false;

    var tags = apps.map(function (a) { return a.title; }).filter(Boolean);
    // Een staffelkorting kent Shopify per REGEL toe, niet op mandniveau. Zonder deze
    // lus blijft alleen het 'aanbieding'-label over en zie je nooit WELKE korting je kreeg.
    cart.items.forEach(function (i) {
      (i.discounts || []).forEach(function (d) {
        if (d.title && tags.indexOf(d.title) < 0) tags.push(d.title);
      });
    });
    (cart.discount_codes || []).forEach(function (d) {
      if (d.applicable && tags.indexOf(d.code) < 0) tags.push(d.code);
    });
    if (compareSavings) tags.unshift(t('sale'));
    // Shopify levert de kortingsnaam in één taal (de titel van de korting). Per markt
    // vertalen waar we 'm kennen; een onbekende naam tonen we onvertaald in plaats van te raden.
    var namen = I18N.discountNames || {};
    tags = tags.map(function (x) { return namen[x] || x; });
    // In een vaste container schrijven; outerHTML vervangen liet bij elke render
    // een extra label achter (Shopify meldt dezelfde korting per regel).
    var seen = {};
    var unique = tags.filter(function (x) { if (seen[x]) return false; seen[x] = 1; return true; });
    el('[data-ecd-discount-tags]').innerHTML = unique.map(function (x) {
      return '<span class="ecd-discount-tag">' + esc(x) + '</span>';
    }).join('');
    el('[data-ecd-discount-amount]').textContent = '-' + money(total);
  }

  function renderUpsells(cart) {
    var box = el('[data-ecd-upsells]');
    if (!box || !(CFG.upsells && CFG.upsells.enabled)) return;
    if (upsellsLoaded || !cart.items.length) return;
    upsellsLoaded = true;

    var pid = cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + (CFG.upsells.limit || 10) + '&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });
        var items = (data.products || []).filter(function (p) { return !inCart[p.id]; });
        if (!items.length) return;
        box.hidden = false;
        el('[data-ecd-upsell-track]').innerHTML = items.map(function (p) {
          var v = p.variants && p.variants[0];
          if (!v) return '';
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var was = (v.compare_at_price && v.compare_at_price > v.price)
            ? '<span class="ecd-upsell-price-was">' + money(v.compare_at_price) + '</span>' : '';
          return '<div class="ecd-upsell-card"><div class="ecd-upsell-product">' +
            '<a class="ecd-upsell-img" href="' + esc(p.url || ('/products/' + p.handle)) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="ecd-upsell-content">' +
              '<a class="ecd-upsell-name" href="' + esc(p.url || ('/products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
              (p.variants && p.variants.length > 1
                ? '<div class="ecd-upsell-variant"><select data-ecd-upsell-variant aria-label="' + esc(t('ariaVariant')) + '">' +
                  p.variants.map(function (vv) {
                    return '<option value="' + vv.id + '"' + (vv.available ? '' : ' disabled') + '>' + esc(vv.title) + '</option>';
                  }).join('') + '</select></div>'
                : '') +
              '<div class="ecd-upsell-price">' +
                '<span class="ecd-upsell-price-now">' + money(v.price) + '</span>' + was +
              '</div>' +
            '</div>' +
            '<button type="button" class="ecd-upsell-add" data-ecd-upsell-add="' + v.id + '">' +
              '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 3.5v9M3.5 8h9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
              '<span>' + esc(t('upsellBtn', CFG.upsells.buttonText)) + '</span>' +
            '</button>' +
          '</div></div>';
        }).join('');
      })
      .catch(function () { /* aanbevelingen zijn optioneel: stil falen */ });
  }

  // ── Verzendbescherming ────────────────────────────────────────────
  // Eigen Shopify-product als gewone cart-regel. Staat standaard aan; de klant kan
  // 'm uitzetten. Eén keer per sessie automatisch toevoegen — zet de klant 'm uit,
  // dan blijft dat zo (anders vecht de drawer met de bezoeker).
  var PROT = CFG.protection || {};
  var protVariantId = PROT.variantId ? parseInt(PROT.variantId, 10) : 0;
  var protBusy = false;
  var protAutoAdded = false;      // grendel: één automatische toevoeging per paginabezoek
  var PROT_OPTOUT = 'ecdProtectionOptOut';

  function protLine(cart) {
    if (!protVariantId) return null;
    var idx = -1, line = null;
    cart.items.forEach(function (i, n) { if (i.variant_id === protVariantId) { idx = n + 1; line = i; } });
    return line ? { line: idx, item: line } : null;
  }

  function optedOut() {
    try { return sessionStorage.getItem(PROT_OPTOUT) === '1'; } catch (e) { return false; }
  }
  function setOptOut(v) {
    try { v ? sessionStorage.setItem(PROT_OPTOUT, '1') : sessionStorage.removeItem(PROT_OPTOUT); } catch (e) {}
  }

  function renderProtection(cart) {
    var wrap = el('[data-ecd-protection-wrap]');
    if (!wrap || !protVariantId) return;

    // Alleen tonen als er iets te beschermen valt.
    var hasRealItems = cart.items.some(function (i) { return i.variant_id !== protVariantId; });
    if (!hasRealItems) { wrap.hidden = true; return; }
    wrap.hidden = false;

    var found = protLine(cart);
    var present = !!found;

    // Twee gelijktijdige refreshes zagen allebei 'nog niet aanwezig' en voegden 'm
    // allebei toe -> aantal 2. Meer dan één is nooit gewenst: terugzetten naar 1.
    if (found && found.item.quantity > 1 && !protBusy) {
      protBusy = true;
      fetch('/cart/change.js', { method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: found.line, quantity: 1 }) })
        .then(function () { protBusy = false; refresh(); })
        .catch(function () { protBusy = false; });
      return;
    }
    el('[data-ecd-protection-name]').textContent = t('protName');
    el('[data-ecd-protection-desc]').innerHTML =
      esc(t('protDesc')) + ' <span class="ecd-protection-price">' +
      esc(money(PROT.price || 495)) + '</span>';
    var tog = el('[data-ecd-protection-toggle]');
    tog.setAttribute('aria-checked', present ? 'true' : 'false');
    tog.disabled = protBusy;

    // Standaard aan: één keer toevoegen, tenzij de klant 'm eerder uitzette.
    if (PROT.defaultOn && !present && !optedOut() && !protBusy && !protAutoAdded) {
      protAutoAdded = true;   // synchroon zetten, vóór de fetch
      protBusy = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: protVariantId, quantity: 1 }] })
      }).then(function () { protBusy = false; refresh(); })
        .catch(function () { protBusy = false; });
    }
  }

  function toggleProtection() {
    if (!protVariantId || protBusy) return;
    protBusy = true;
    root.classList.add('is-busy');
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var found = protLine(cart);
      if (found) {
        setOptOut(true);
        protAutoAdded = true;   // niet automatisch terugzetten na uitzetten
        return fetch('/cart/change.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: found.line, quantity: 0 }) });
      }
      setOptOut(false);
      return fetch('/cart/add.js', { method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: protVariantId, quantity: 1 }] }) });
    }).then(function () { protBusy = false; return refresh(); })
      .then(function () { root.classList.remove('is-busy'); })
      .catch(function () { protBusy = false; root.classList.remove('is-busy'); });
  }

  // ── Cart-verkeer ──────────────────────────────────────────────────
  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return loadProducts(cart).then(function () { return cart; });
      })
      .then(function (cart) {
        renderItems(cart); renderReward(cart); renderTotals(cart); renderUpsells(cart);
        renderProtection(cart);
        announceCartChange(cart);
        var btn = el('[data-ecd-checkout]');
        if (btn) btn.disabled = cart.item_count === 0;
        return cart;
      });
  }

  // Cart-events uitzenden waar thema's/apps op luisteren. Bewust GEEN eigen
  // pixel-events publiceren: op deze store vuurt ook de gewone productpagina-knop
  // geen product_added_to_cart, dus dat zou de tracking scheeftrekken i.p.v. herstellen.
  // De aankoop-conversie loopt sowieso via Shopify's checkout-pixels; de afrekenknop
  // post naar /cart met name="checkout", exact de standaardroute.
  function announceCartChange(cart) {
    ['cart:updated', 'cart:refresh', 'cart:change', 'ecd:updated'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: { cart: cart } }));
    });
    if (typeof window.updateCartCount === 'function') { try { window.updateCartCount(); } catch (e) {} }
  }

  function change(body) {
    root.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function () { return refresh(); })
      .catch(function () { return refresh(); })
      .then(function (cart) { root.classList.remove('is-busy'); announceCartChange(cart); return cart; });
  }

  // ── Events ────────────────────────────────────────────────────────
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ecd-close],[data-ecd-remove],[data-ecd-qty],[data-ecd-upsell-add],[data-ecd-upsell-prev],[data-ecd-upsell-next],[data-ecd-protection-toggle]');
    if (!t) return;

    if (t.hasAttribute('data-ecd-protection-toggle')) { e.preventDefault(); return toggleProtection(); }

    if (t.hasAttribute('data-ecd-close')) { e.preventDefault(); return close(); }

    if (t.hasAttribute('data-ecd-remove')) {
      e.preventDefault();
      return change({ line: parseInt(t.dataset.line, 10), quantity: 0 });
    }

    if (t.hasAttribute('data-ecd-qty')) {
      e.preventDefault();
      var row = t.closest('.ecd-qty');
      var current = parseInt(row.querySelector('.ecd-qty-value').textContent, 10) || 1;
      var next = current + parseInt(t.getAttribute('data-ecd-qty'), 10);
      return change({ line: parseInt(t.dataset.line, 10), quantity: Math.max(next, 0) });
    }

    if (t.hasAttribute('data-ecd-upsell-add')) {
      e.preventDefault();
      root.classList.add('is-busy');
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(selectedVariantFor(t), 10), quantity: 1 }] })
      }).then(function () { upsellsLoaded = false; return refresh(); })
        .then(function () { root.classList.remove('is-busy'); });
    }

    var track = el('[data-ecd-upsell-track]');
    if (track && t.hasAttribute('data-ecd-upsell-prev')) { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); }
    if (track && t.hasAttribute('data-ecd-upsell-next')) { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); }
  });

  // Shopify's /cart/change.js KAN geen variant omwisselen — 'id' dient daar om de
  // REGEL aan te wijzen, niet om er een andere variant van te maken. De oude aanroep
  // hier deed dus niets (en gooide het aantal bovendien terug naar 1). Een swap is
  // 'oude variant naar 0 + nieuwe variant erbij', en dat kan /cart/update.js in EEN
  // call — belangrijk, want twee losse calls laten de cart even op 1 product staan
  // en dat zou de staffelkorting zichtbaar laten wegspringen.
  function swapVariant(sel) {
    var oldId = parseInt(sel.getAttribute('data-current'), 10);
    var newId = parseInt(sel.value, 10);
    if (!newId || newId === oldId) return Promise.resolve();
    root.classList.add('is-busy');
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var moving = 0, already = 0;
        cart.items.forEach(function (i) {
          if (i.variant_id === oldId) moving += i.quantity;
          if (i.variant_id === newId) already += i.quantity;
        });
        if (!moving) return null;                    // regel is intussen al weg
        var updates = {};
        updates[oldId] = 0;
        // Optellen, niet overschrijven: zit de nieuwe maat al in de cart, dan moet
        // die niet stilletjes terugvallen naar het aantal van de oude regel.
        updates[newId] = already + moving;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      // Mislukt de wissel (net uitverkocht, netwerk), dan hertekent refresh() uit de
      // ECHTE cart en springt de dropdown vanzelf terug naar de variant die er staat.
      .then(function () { return refresh(); })
      .catch(function () { return refresh(); })
      .then(function (cart) { root.classList.remove('is-busy'); return cart; });
  }

  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ecd-variant]');
    if (!sel) return;
    swapVariant(sel);
  });

  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // Elke link naar /cart opent de drawer i.p.v. de cartpagina.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-ecd-open]');
    if (!link) return;
    e.preventDefault();
    open();
  });

  // Openen zodra er iets aan de winkelwagen is toegevoegd (theme-agnostisch:
  // we onderscheppen de fetch naar /cart/add).
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = (typeof url === 'string') ? url : (url && url.url) || '';
    var result = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?/.test(href)) {
      result.then(function () {
        if (/\/cart\/add/.test(href)) { upsellsLoaded = false; open(); }
        else if (root.classList.contains('is-open')) refresh();
      }).catch(function () {});
    }
    return result;
  };

  window.ecDrawer = { open: open, close: close, refresh: refresh };
})();
